import React from 'react'
import styled, { css } from 'styled-components'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

export const StyledSubList = styled(List)`
  && {
    padding-left: 0px;
    background-color: #E8EAF6;
  }
`

export const StyledListItemText = styled(({ rootLevel, isSubitem, ...props }) => <ListItemText {...props} />)`
  && {
    ${({ rootLevel }) => rootLevel && css`white-space: nowrap;`};
    width: fit-content;
  }
  .MuiTypography-root{
    ${({ isSubitem }) => !isSubitem && css`white-space: nowrap;`}
  }
`

export const StyledListItem = styled(({ selected, isSubitem, ...props }) => <ListItem {...props} />)`
  padding-left: ${({ isSubitem }) => isSubitem ? '24px' : '16px'};

  .MuiListItemIcon-root {
    color: #060A23;
    & svg, & svg path, & svg circle {
      fill: currentColor !important;
    }
  }

  &&:hover {
    background-color: #F0F2FF;
    cursor: pointer;
    border-left: ${({ isSubitem }) => !isSubitem ? '4px solid #FD0A7A' : 'none'};
    .MuiTypography-root, .MuiListItemIcon-root, svg {
      color: #2036C7 !important;
    }
    .MuiListItemIcon-root svg, .MuiListItemIcon-root svg path, .MuiListItemIcon-root svg circle {
      fill: #2036C7 !important;
    }
  }

  ${({ selected, isSubitem }) => selected && css`
    border-left: ${!isSubitem ? '4px solid #FD0A7A' : 'none'};
    background-color: #E8EAF6;

    .MuiTypography-root {
      color: #2036C7 !important;
      font-weight: 600;
    }

    .MuiListItemIcon-root {
      color: #2036C7 !important;
      & svg, & svg path, & svg circle {
        fill: #2036C7 !important;
      }
    }
  `}
`
